// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/module/htmlTextbox/htmlTextbox.js#1 $
'use strict';

angular.module('tcApp')
.directive('tcHtmlTextbox', function($q, $timeout, $ocLazyLoad, tcConstants) {
	return {
		require: ['^ngModel','?^tcComponent'],
		restrict: 'E',
		templateUrl: 'template/htmlTextbox/htmlTextbox.html',
		scope: {
			htmltextboxId: '@tcHtmltextboxId',
			htmltextboxName: '@tcHtmltextboxName',
			componentForm: '=tcComponentForm',
			disabled: '=ngDisabled',
			readOnly: '=ngReadonly',
			ariaLabel: '@ariaLabel',
			title: '@title'
		},
		link: function(scope, elm, attr, controllers) {
			// Add this controller to FormController.
			var ngModel = controllers[0];
			ngModel.$name = scope.htmltextboxName;
			scope.componentForm.$addControl(ngModel);
			scope.viewModel = {
				displayErrorBorder: false
			};
			
			var editor;
			var focusManager;
			var noChangeEvent = false;
			var initialized = false;
			var isLookup = attr.tcHtmltextboxIslookup === '1';
			var toolbarDiv = elm[0].firstElementChild;
			var textboxDiv = toolbarDiv.nextElementSibling;
			var parentComponentHtmlName = controllers[1].componentHtmlName;
			
			if (attr.disabled || attr.readOnly || scope.disabled || scope.readOnly) {
				textboxDiv.contentEditable = false;
			}
			
			ngModel.$render = function() {
				if (isLookup && scope.$parent.$parent.isOpen()) {
					noChangeEvent = true;
				}
				if (editor) {
					editor.setData(ngModel.$modelValue.value);
					ngModel.$validate();
					if (focusManager.hasFocus) {
						moveCursorToEnd();
					}
				}
				noChangeEvent = false;
			};
			
			// Custom validation for ckeditor.
			ngModel.$validators.required = function(modelValue) {
				var isValid = true;
				if (modelValue.required && ngModel.$isEmpty(modelValue.value)) {
					isValid = false;
				}
				if (scope.componentForm && scope.componentForm[scope.htmltextboxName]) {
					scope.componentForm[scope.htmltextboxName].$setValidity('required', isValid);
				}
				scope.viewModel.displayErrorBorder = !isValid;
				return isValid;
			};
			
			var setupEditor = function() {
				if (angular.isDefined(CKEDITOR)) {
					CKEDITOR.disableAutoInline = true;
					var ck = CKEDITOR.inline(textboxDiv, {
						customConfig: 'htmltextbox_config.js',
						sharedSpaces: {
							top: toolbarDiv
						}
					});
					textboxDiv.contentEditable = true;
				} else {
					return false;
				}
			
				ck.on('focus', function() {
					toolbarDiv.className = 'toolbarShow';
				});
			
				ck.on('blur', function() {
					toolbarDiv.className = 'toolbarHidden';
				});
			
				ck.on('key', function(e) {
					if (e.data.keyCode == tcConstants.KEY_CODE.ENTER 
							|| e.data.keyCode == CKEDITOR.SHIFT + tcConstants.KEY_CODE.ENTER) {
						e.cancel();
					}
					if (isLookup) {
						scope.$parent.$parent.handleKeyDown(e.data.domEvent.$);
						// force to unrender lookup after enter/tab is pressed.
						scope.$apply();
					}
				});
			
				ck.on('change', function() {
					if (!noChangeEvent) {
						// check again if data is actually changed
						// CKEditor does not verify if content is actually changed.
						// http://docs.ckeditor.com/#!/api/CKEDITOR.editor-event-change
						var ckData = cleanTag(ck.getData());
						var modelValue = cleanTag(ngModel.$modelValue.value);
						if (ckData !== modelValue) {
							var formDirty = scope.componentForm.$dirty;
							updateModel(ckData);
							// Don't fire the lookup where the field has an initial value
							if (initialized) {
								if (isLookup) scope.$parent.$parent.handleValueChange();
							} else {
								ngModel.$setPristine();
								// Pristine state does not bubble up automatically to form
								if (!formDirty) scope.componentForm.$setPristine();
							}
						}
					}
				});

				ck.on('instanceReady', function() {
					if (angular.isDefined(ngModel.$modelValue.value)) {
						ck.setData(ngModel.$modelValue.value);
					}
					initialized = true;
				});
				
				return ck;
			};			

			$ocLazyLoad.load('../scripts/system/ckeditor/ckeditor.js').then(function() {
				$timeout(function() {
					editor = setupEditor();
					if (editor) {
						focusManager = CKEDITOR.focusManager(editor);
					}
				});
			});

			function updateModel(ckData) {
				scope.$apply(function() {
					ngModel.$viewValue.value = ckData;
					ngModel.$commitViewValue();
					ngModel.$setDirty();
					ngModel.$validate();
				});
			}
			
			function cleanTag(str) {
				// Strip <p> tags and new lines
				return str.replace(/<\/?p>|\r?\n|\r/gi, '');
			}
			
			function moveCursorToEnd() {
				var range = editor.createRange();
				range.moveToElementEditEnd(range.root);
				editor.getSelection().selectRanges([range]);
			}
			
			scope.$on('tcHtmlTextBox:focus', function($event, componentHtmlName, itemName) {
				if ((parentComponentHtmlName === componentHtmlName) && (itemName === scope.htmltextboxName)) {
					editor.focus();
					moveCursorToEnd();
				}
			});
		}
	};
});
